/**
 * @license @lucide/vue v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import { provide, inject } from 'vue';

const LUCIDE_CONTEXT = Symbol("lucide-icons");
function setLucideProps(props) {
  return provide(LUCIDE_CONTEXT, props);
}
function useLucideProps() {
  return inject(LUCIDE_CONTEXT, {});
}

export { LUCIDE_CONTEXT, setLucideProps, useLucideProps };
//# sourceMappingURL=context.mjs.map
